// @flow
import moment from 'moment';

type Row = {
  Header: string,
  key: string,
  result?: string,
  minWidth?: number,
  accessor?: string | (any) => void
}

type Props = Array<Row>

class Columns {
  constructor(rows: Props = [], coin: string): Props {
    this.coin = coin;
    if (!rows.length) return [];
    return rows.map((item) => {
      if (typeof item.Header === 'string') {
        return this.rows[item.accessor](item);
      }
      // eslint-disable-next-line max-len
      return (this.rows[item.Header.key] ? this.rows[item.Header.key](item.Header) : this.rows.custom(item.Header));
    });
  }

  coin: string = '';

  // constructor for columns
  pattern = ({
    key = '', accessor, ...props
  }: any): any => ({
    id: key,
    className: key,
    accessor: accessor || key,
    ...props,
  });

  rows: any = {
    payment_date: (props) => this.pattern({
      accessor: 'payment_date',
      Header: '',
      width: props.width,
      Cell: (row) => moment(row.value).format('D/MM/YY LT'),
      ...props,
    }),
    payment_method: (props) => this.pattern({
      accessor: 'payment_method',
      Header: '',
      width: props.width,
      ...props,
    }),
    type: (props) => this.pattern({
      accessor: 'type',
      Header: '',
      width: props.width,
      ...props,
    }),
    value: (props) => this.pattern({
      accessor: 'value',
      Header: '',
      width: props.width,
      ...props,
    }),
    email: (props) => this.pattern({
      accessor: 'email',
      Header: '',
      width: props.width,
      ...props,
    }),
    bonus_sum: (props) => this.pattern({
      accessor: 'bonus_sum',
      Header: '',
      width: props.width,
      ...props,
    }),
    updated_at: (props) => this.pattern({
      accessor: 'updated_at',
      Header: '',
      width: props.width,
      Cell: (row) => moment(row.value).format('D/MM/YY LT'),
      ...props,
    }),
    amount: (props) => this.pattern({
      accessor: 'amount',
      Header: '',
      width: props.width,
      ...props,
    }),
    method: (props) => this.pattern({
      accessor: 'method',
      Header: '',
      width: props.width,
      ...props,
    }),
    status: (props) => this.pattern({
      accessor: 'status',
      Header: '',
      width: props.width,
      ...props,
    }),

    // If needed custom column
    custom: (props) => this.pattern({ ...props }),
  }
}

export default Columns;
